import { h } from "preact";

import IconProps from "./IconProps";

function IconAIHighlight({
    class: cssClass
}: IconProps) {
    return (
        <svg class={cssClass} width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.96.68c.373-.85 1.527-.903 1.998-.159l.084.16v.002l.617 1.413.044.078a.48.48 0 0 0 .203.169l1.407.614.01.004.158.085c.741.472.688 1.622-.161 1.995l-.002.001-1.412.617a.48.48 0 0 0-.247.247l-.615 1.41h-.001c-.401.924-1.696.9-2.085-.003L2.36 5.927l-.043-.08a.482.482 0 0 0-.202-.17L.677 5.043l.001-.001c-.907-.4-.902-1.687.005-2.082l1.412-.616.078-.044a.48.48 0 0 0 .17-.203L2.958.683V.68zm1.167.402a.137.137 0 0 0-.251 0l-.617 1.413-.061.125a1.48 1.48 0 0 1-.701.639l-1.279.557-.136.061-.037.021a.138.138 0 0 0 .037.23l1.438.636c.34.15.612.425.76.767l.597 1.386c.047.11.203.11.25 0l.616-1.411a1.48 1.48 0 0 1 .637-.701l.125-.063 1.413-.616a.137.137 0 0 0 0-.251l-1.413-.616a1.48 1.48 0 0 1-.7-.639l-.062-.125-.616-1.413z" fill="#fff"/>
        </svg>
    );
}

export default IconAIHighlight;
